// extracted by mini-css-extract-plugin
export default {"root":"PageCousinE_root__uc7V7","inner":"PageCousinE_inner__C7v6T","content":"PageCousinE_content__qoJHh","back":"PageCousinE_back__my54H"};